var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingQuestionIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9009 4.31653C12.5322 3.57383 11.4719 3.57655 11.1071 4.32114L9.175 8.26485C9.0297 8.56143 8.74733 8.76714 8.42048 8.81454L4.00227 9.45521C3.18256 9.57407 2.85444 10.5809 3.44671 11.1599L6.65228 14.2938C6.88832 14.5246 6.99527 14.8569 6.93811 15.182L6.18254 19.4791C6.03821 20.3 6.90241 20.9268 7.63786 20.5347L11.5289 18.4604C11.8229 18.3036 12.1757 18.3036 12.4697 18.4603L16.365 20.5365C17.1 20.9282 17.9637 20.3025 17.8205 19.4821L17.0698 15.1808C17.0131 14.8564 17.1199 14.5249 17.3552 14.2944L20.5575 11.1582C21.1488 10.5792 20.821 9.57364 20.0021 9.45423L15.6142 8.81441C15.2894 8.76706 15.0086 8.56339 14.8627 8.26943L12.9009 4.31653Z",
    fill: "#CE779D",
    stroke: "#CE779D",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingQuestionIcon5);
export default __webpack_public_path__ + "static/media/landing_question_icon5.5cf17c648dcb237d899a67e4eddf081f.svg";
export { ForwardRef as ReactComponent };